import { useRootPlaceMenuItemQuery } from '~/libs/gql/queries/root_places/rootPlaceMenuItemQuery.generated';
import { type DishListMenuItemQuery_dishList_DishList_menuItem_MenuItem as MenuItemData, useDishListMenuItemQuery } from '~/libs/gql/queries/dish_lists/dishListMenuItemQuery.generated';

type UseMenuItemDataArgs = {
  dishListSlug?: string | null | undefined
  menuItemId: number | null | undefined
  rootPlaceSlug?: string | null | undefined
}

export const useMenuItemData = ({ dishListSlug, menuItemId, rootPlaceSlug }: UseMenuItemDataArgs) => {
  const placeQuery = useRootPlaceMenuItemQuery({
    skip: !menuItemId || !rootPlaceSlug,
    variables: {
      menuItemId: menuItemId ?? -1,
      rootPlaceSlug: rootPlaceSlug ?? '',
    },
  });
  const listQuery = useDishListMenuItemQuery({
    skip: !menuItemId || !dishListSlug,
    variables: {
      dishListSlug: dishListSlug ?? '',
      menuItemId: menuItemId ?? -1,
    },
  });

  const data = placeQuery.data?.rootPlace?.menuItem || listQuery.data?.dishList?.menuItem;
  const loading = placeQuery.loading || listQuery.loading;
  return {
    data: data as MenuItemData | null,
    loading,
  };
};
